<template>
  <div>
    <Header></Header>
    <breadcrumb :secondhref="secondhref" :secondtest="secondtest"></breadcrumb>
    <div class="content-body body-box" style="padding-bottom: 30px">
      <!--审核状态UI-->
      <div class="processBody1" >
        <el-steps :active="active" align-center finish-status="success">
          <el-step title="注册" description=""></el-step>
          <el-step title="初审"></el-step>
          <el-step title="终审"></el-step>
          <el-step title="交费"></el-step>
          <el-step title="正式会员"></el-step>
        </el-steps>
      </div>
      <!--<p>当前审核状态：{{status}}</p>-->
      <!--审核盒子-->
      <div class="processBody"><!--v-if="this.status === 0"-->
        <process-dataexamine v-if="this.status === 0"></process-dataexamine><!--0 待初审-->
        <process-dataexamine2 v-if="this.status === 1"></process-dataexamine2><!--1 初审成功，待终审-->
        <process-dataexamine3 v-if="this.status === 2" :primary_mark="primaryMark"></process-dataexamine3><!--2 初审失败-->
        <process-pay v-if="false" :amountTotal="amountTotal" :confirmedAt="confirmedAt" @listenToChild="showFromChild"></process-pay><!--3 终审成功，待交费-->
        <!--3 终审成功，待交费，这里把支付宝和微信的支付方式隐藏了，改成直接显示银行卡-->
        <div v-if="this.status === 3" class="dataBox">
          <span>恭喜！您已于 <span style="color: #418fbf">{{confirmedAt}}</span> 通过终审！请在5日内一次缴纳五年会员费用。<br>应缴纳的会员费用为：<span style="color: red">{{amountTotal}}</span> 元</span>
          <div style="width: 400px;position:relative;background-color: #eeeeee;margin: 30px auto;padding: 20px;font-size: 12px">
            <p style="text-align: right;position: absolute;right: 10px;top: 10px;color: #949494">转账信息</p>
            <p>账  号：3602015809100002730</p>
            <p>户  名：广东省仪器仪表学会</p>
            <p style="margin-bottom: 0px">开户行：中国工商银行广州暨南大学支行</p>
          </div>
        </div>
        <process-dataexamine4 v-if="this.status === 4" :final_mark="finalMark"></process-dataexamine4><!--4 终审失败-->
        <process-paysuccess v-if="this.status === 6"></process-paysuccess><!--6 交费成功，等待确认-->
        <process-success v-if="this.status === 7"></process-success><!--7 恭喜您，正式加入广东省仪器仪表学会-->
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
/* eslint-disable */
import Footer from '@/components/footer/footer.vue'
import Header from '@/components/header/header.vue'
import breadcrumb from '@/components/breadcrumb/breadcrumb.vue'
import processPay from '@/components/joinprocess/processPay.vue'
import processPaysuccess from '@/components/joinprocess/processPaysuccess.vue'
import processSuccess from '@/components/joinprocess/processSuccess.vue'
import processDataexamine from '@/components/joinprocess/processDataexamine.vue'
import processDataexamine2 from '@/components/joinprocess/processDataexamine2.vue'
import processDataexamine3 from '@/components/joinprocess/processDataexamine3.vue'
import processDataexamine4 from '@/components/joinprocess/processDataexamine4.vue'
import HttpServer from '@/utils' // 接口请求
import '../../node_modules/bootstrap/dist/js/bootstrap.js'

export default {
  name: 'joinProcess',
  data () {
    return {
      // token验证码
      token: this.$store.state.Token,
      // 所在页面的名称
      topName: 'joinProcess',
      // 顶部导航栏
      ifblueme: {
        color: '#0051bd'
      },
      // 副导航栏
      ifSelection: 0,
      // 面包屑导航栏
      secondhref: '/joinProcess',
      secondtest: '审核流程',
      // 副导航栏信息
      cate: [],
      // 会员信息
      member: [],
      // 审核状态
      status: null,
      // 需缴纳金额
      amountTotal: 0,
      // 审核成功的日期
      confirmedAt: '',
      // 审核的进度条的数值
      active: 1,
      // 初审失败的原因
      primaryMark: '',
      // 终审失败的原因
      finalMark: '',

      login_before: false
    }
  },
  components: {
    Footer: Footer,
    Header: Header,
    breadcrumb: breadcrumb,
    processDataexamine: processDataexamine,
    processDataexamine2: processDataexamine2,
    processDataexamine3: processDataexamine3,
    processDataexamine4: processDataexamine4,
    processPay: processPay,
    processPaysuccess: processPaysuccess,
    processSuccess: processSuccess
  },
    watch:{
    // 状态变化时转换登录参数
    active( newval){
      if (parseInt(newval) === 5){
        if (!this.login_before){
          this.login_before = true
          this.$store.commit('setLoginInfo', true)
        }
        else{
          this.$router.push('/')
        }
      }
    }
  },
  mounter () {
    // 开始就判断是否要跳转
    if (this.login_before) {
      this.$router.push('/')
    }
  },
  methods: {
    // 副导航栏
    viceNavigation (event) {
      this.ifSelection = +event.target.id
      HttpServer.get('http://ysw.861718.com/gdics.php/index?act=' + this.topName + '&cateid=' + this.ifSelection).then(res => {
        this.member = res.member
        this.cate = res.cate
      })
    },
    // 拿子元素传过来的支付成功状态码6
    showFromChild (active) {
      this.$state
      this.active = active
    },
   // 正式会员时触发sessionstorage改变
    changeActive () {
      this.$store.commit('getLoginInfo');
      this.login_before = this.$store.state.login_ok;
      if (parseInt(this.active) === 5){
            this.$store.commit('setLoginInfo',true);
            this.login_before = true
      }
    }
  },
  created () {
    // 定义请求头
    let config = {
      headers: {
        'Authorization': 'Bearer' + this.$store.state.Token
      }
    }
    // 获取以前登录信息
    // this.login_before = window.sessionStorage.getItem('ok') || false;

    // 调用接口-渲染用户信息
    this.$http.get('http://api.gdics.cn/api/userinfo', config)
    // 请求成功
      .then(function (res) {
        console.log(res.body.data)
        // 审核状态
        this.status = res.body.data.status
        // 获取是否登录过的信息(分别从Vuex和local中获取)
        this.login_before = this.$store.state.login_ok || window.sessionStorage.getItem('login_in_before')
        // 根据参数判断是否第一次登录，不是返回首页
        if (this.login_before === 'true' && this.status === 7) { this.$router.push('/') }

        if (this.status === 0) { // 待审核
          this.active = 1
        } else if (this.status === 1) { // 审核成功，待初审
          this.active = 2
        } else if (this.status === 2) { // 初审失败
          this.active = 1
          // 传初审失败原因
          this.primaryMark = res.body.data.primary_mark
        } else if (this.status === 3) { // 终审成功，待缴费
          this.active = 3
          // 传终审通过的时间
          this.confirmedAt = res.body.data.confirmed_at
        } else if (this.status === 4) { // 终审失败
          this.active = 2
          // 传终审失败原因
          this.finalMark = res.body.data.final_mark
        } else if (this.status === 5) { // 缴费失败（暂时保留）
          this.active = 1
        } else if (this.status === 6) { // 缴费成功，等待确认
          this.active = 4
        } else if (this.status === 7) { // 成为正式会员,跳去成为正式会员页面
          this.active = 5
          this.changeActive()
        }
        // 缴纳金额(单位：分)
        this.amountTotal = (res.body.data.amount_total / 100).toFixed(2)
        // 把会员类型group传给vuex
        this.$store.commit('getGroup', res.data.data.group)
      })
      // 请求失败
      .catch(function (err) {
        console.log(err)
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  @import '../../node_modules/bootstrap/dist/css/bootstrap.css';
  @import 'joinprocess/main.css';
  .processBody{
    position: relative;
    width: 800px;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    background-color: #ffffff;
    height: 400px
  }
  .processBody1{
    position: relative;
    width: 800px;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    background-color: #f5f5f5;
  }
  .body-box{
    margin-top:10px;
    background-color: #f5f5f5;
    min-height: 600px;
  }
  .onloadBox p{
    font-size: 12px;
    color: #999999;
  }
  .onloadBox input{

  }
  .onloadSpanBox p{
    width: 100%;
    margin-bottom: 34px;
    float: right;
    color: #999999;
  }
  /* 文件选择标签 */
  .a-upload {
    padding: 4px 10px;
    height: 20px;
    line-height: 20px;
    position: relative;
    cursor: pointer;
    color: #888;
    background: #fafafa;
    border: 1px solid #ddd;
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;
    *display: inline;
    *zoom: 1
  }
  .a-upload  input {
    position: absolute;
    font-size: 100px;
    right: 0;
    top: 0;
    opacity: 0;
    filter: alpha(opacity=0);
    cursor: pointer
  }
  .a-upload:hover {
    color: #444;
    background: #eee;
    border-color: #ccc;
    text-decoration: none
  }
  .dataBox{
    padding-top: 100px;
  }
  .dataBox span{
    color: #4e4e4e;
    font-size: 18px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/joinProcess.vue